'use strict';

function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService)
{
    let async = require('async');
    let model = this;

    $scope.global = Global;
    model.settings = settings;
    model.color = d3.scale.category10();

    model.lineChartIdentifiers = { key: false, id: false };
    model.pieChartIdentifiers = { key: false, id: false };
    model.tableIdentifiers = { key: false, id: false };

    let obj = {};

    socketIo('/api/hunting/long_duration_conns').then(function(socket)
    {
        /* --------*/
        /*  TABLE  */
        /* --------*/

        // Register data object.
        $scope.main.registerVisual(
        {
            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
            searchable: true, // Optional search param... no if undefined.
            get:
            {
                call: 'table',
                socket: socket
            },
            hideToggleBytes: true,
            grouping: ['id'],
            sort:
            {
                direction: '-',
                col: 'duration'
            },
            title: 'Events',
            columns:
            [
                {
                    title: 'Time',
                    select: 'time',
                    dView: true
                },
                {
                    title: 'Duration (seconds)',
                    select: 'duration',
                    dView: true
                },
                {
                    title: 'Origin IP',
                    select: 'orig_ip',
                    dView: true
                },
                {
                    title: 'Origin Port',
                    select: 'orig_port',
                    dView: true
                },
                {
                    title: 'Responder IP',
                    select: 'resp_ip',
                    dView: true
                },
                {
                    title: 'Responder Port',
                    select: 'resp_port',
                    dView: true
                },
                {
                    title: 'Vector',
                    select: 'vector',
                    dView: true
                }
            ],
            searchCategories:
            {
                'time': 'Time',
                'orig_ip': 'Origin IP',
                'orig_port': 'Origin Port',
                'resp_ip': 'Responder IP',
                'resp_port': 'Responder  Port',
                'vector': 'Vector'
            }
        })
        .then(function(result) // Fetch the data when the object is registered.
        {
            model.tableIdentifiers = { id: result.id, key: result.key };
            // Initialize table with column information so it can compile the directive.
            $scope.$broadcast('table-build', model.tableIdentifiers);

            let time = angular.copy($scope.main.getTime());

            model.loadStart = time.end;
            model.loadEnd = time.end;
            // Return promise to build dimensions and groups for table.
            return new fetchStream(result.settings.get.call, result.settings.get.socket);
        })
        .then(function(result)
        {
            model.complete = true;
            // Stop the table spinner as soon as the resolve comes in.
            usSpinnerService.stop(model.tableIdentifiers.id);
        },
        function(err)
        {
            // Nothing to do here.
        },
        function(result)
        {
            // Add rows.
            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);

            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched)
            {
                // With our first data return, we can build dimensions and groups for our data.
                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function()
                {
                    // Don't start the spinner if the table loads faster than building group dim.
                    // Start table spinner right before init, but after build.
                    if (!model.complete)
                        usSpinnerService.spin(model.tableIdentifiers.id);
                    // Initialize rows.
                    $scope.$broadcast('init', model.tableIdentifiers);

                    if (result.min)
                        model.loadStart = result.min;
                },
                function(err)
                {
                    console.log('error');
                    console.log(err);
                });
            }

            else
            {
                if (result.min)
                    model.loadStart = result.min;

                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
            }
        });

        $scope.$on('$destroy', function()
        {
            socket.disconnect();
        });
    });
}

ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
module.exports = ctrl;


/** WEBPACK FOOTER **
 ** ./src/pages/controllers/hunting/long_duration_conns.js
 **/